import Vue from 'vue'
import Router from 'vue-router'
import { getToken, removeToken } from '@/utils/auth' // get token from cookie
import { MessageBox, Message, Alert } from 'element-ui'
import { trueNologin, trueEnrolled, trueCertificate } from './utils'
import Vuex from 'vuex';
import { userinfo } from "@/api/login"
import { gethomeinfo, createActive } from "@/api/index"
import index from '@/pages/index/page'
import login from '@/pages/index/page/login'
import indexPage from '@/pages/index/page/indexPage/indexPage'
import wdkc from '@/pages/index/page/wdkc/wdkc'
import khjy from '@/pages/index/page/khjy/khjy'
import khjyIndex from '@/pages/index/page/khjy'
import wdks from '@/pages/index/page/wdks/wdks'
import sxpt from '@/pages/index/page/sxpt/sxpt'
import lxwm from '@/pages/index/page/lxwm/lxwm'
import jxgg from '@/pages/index/page/jxgg/jxgg'
import jxggIndex from '@/pages/index/page/jxgg/index'
import xwzx from '@/pages/index/page/xwzx/xwzx'
import xwzxIndex from '@/pages/index/page/xwzx/index'
import msfc from '@/pages/index/page/msfc/msfc'
import msfcIndex from '@/pages/index/page/msfc/index'
import grzx from '@/pages/index/page/grzx/grzx'
import grzxIndex from '@/pages/index/page/grzx/index/index'
import password from '@/pages/index/page/grzx/password/password'
import pxxz from '@/pages/index/page/grzx/pxxz/pxxz'
import xgxx from '@/pages/index/page/grzx/xgxx/xgxx'
import xydt from '@/pages/index/page/grzx/xydt/xydt'
import xjgl from '@/pages/index/page/grzx/xjgl/xjgl'
import zssq from '@/pages/index/page/grzx/zssq/zssq'
import zsxq from '@/pages/index/page/grzx/zssq/zsxq'
import bmdj from '@/pages/index/page/grzx/bmdj/bmdj'
import courseAssess from '@/pages/index/page/grzx/courseAssess/courseAssess'
import assess from '@/pages/index/page/grzx/courseAssess/assess'
import StudentAction from '@/pages/index/page/grzx/StudentAction/StudentAction'
import examination from '@/pages/index/page/examination/examination'
import examinationIndex from '@/pages/index/page/examination/examinationIndex'
import examinationResults from '@/pages/index/page/examination/examinationResults'

Vue.use(Vuex)
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login', //登陆
      name: 'login',
      component: login,
    },
    {
      path: '/examinationIndex', //考试
      name: 'examinationIndex',
      component: examinationIndex,
    },
    {
      path: '/examinationResults/:id', //考试报告
      name: 'examinationResults',
      component: examinationResults,
    },
    {
      path: '/', //首页顶部
      name: 'index',
      component: index,
      children: [
        {
          path: 'khjy', //结业考试
          name: 'khjy',
          component: khjy,
          children: [
            {
              path: 'index',
              name: 'khjyIndex',
              component: khjyIndex,
            }
          ]
        },
        {
          path: 'examination', //确认考试
          name: 'examination',
          component: examination
        }, {
          path: '',
          name: 'indexPage', //首页
          component: indexPage
        }, {
          path: 'wdkc',   //我的课程
          name: 'wdkc',
          component: wdkc
        }, {
          path: 'wdks', //我的考试
          name: 'wdks',
          component: wdks
        }, {
          path: 'sxpt', //实训平台
          name: 'sxpt',
          component: sxpt
        }, {
          path: 'lxwm', //联系我们
          name: 'lxwm',
          component: lxwm
        }, {
          path: '/jxgg/:id', //信息公告
          name: 'jxgg',
          component: jxgg
        }, {
          path: '/jxggList', //信息公告列表
          name: 'jxggIndex',
          component: jxggIndex
        }, {
          path: '/xwzx/:id', //新闻
          name: 'xwzx',
          component: xwzx
        }, {
          path: '/xwzxList', //新闻中心列表
          name: 'xwzxIndex',
          component: xwzxIndex
        }, {
          path: '/msfc/:id', //名师风采
          name: 'msfc',
          component: msfc
        }, {
          path: '/msfcList', //名师列表
          name: 'msfcIndex',
          component: msfcIndex
        }, {
          path: 'grzx', //个人中心
          name: 'grzx',
          component: grzx,
          children: [
            {
              path: 'index', //个人中心首页
              name: 'grzxIndex',
              component: grzxIndex
            }, {
              path: 'pxxz', //操作手册
              name: 'pxxz',
              component: pxxz
            }, {
              path: 'xgxx', //修改信息
              name: 'xgxx',
              component: xgxx
            }, {
              path: 'xydt', //个人评论
              name: 'xydt',
              component: xydt
            }, {
              path: 'xjgl', //学籍管理
              name: 'xjgl',
              component: xjgl
            }, {
              path: 'zssq', //证书申请
              name: 'zssq',
              component: zssq
            }, {
              path: '/zsxq/:id', //证书详情
              name: 'zsxq',
              component: zsxq
            }, {
              path: 'bmdj', //报名登记
              name: 'bmdj',
              component: bmdj
            }, {
              path: 'courseAssess', //课程评估
              name: 'courseAssess',
              component: courseAssess
            }, {
              path: 'assess/:id', //课程评估
              name: 'assess',
              component: assess
            }, {
              path: 'StudentAction', //个人中心通知
              name: 'StudentAction',
              component: StudentAction
            }, {
              path: 'password',  //修改密码
              name: 'password',
              component: password
            },]
        },]
    }
  ]
})

function roleTrue(certificate, Enrolled, headquarters) {
  if (certificate === true) {
    return 'certificate'
  } else if (Enrolled === 0) {
    return 'notEnrolled'
  } else if (headquarters === true) {
    return 'headquarters'
  } else {
    return 'nonHeadquarters'
  }
}

function checkBrowser() {
  let ua = navigator.userAgent.toLocaleLowerCase();
  let browserType = "", browserVersion = "";
  
  if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
      browserType = "IE";
      //哈哈，现在可以检测ie11.0了！
      browserVersion = ua.match(/msie ([\d.]+)/) != null ? ua.match(/msie ([\d.]+)/)[1] : ua.match(/rv:([\d.]+)/)[1];
  } else if (ua.match(/firefox/) != null) {
      browserType = "Firefox"; // 火狐
  } else if (ua.match(/opera/) != null) {
      browserType = "Opera"; // 欧朋
  } else if (ua.match(/chrome/) != null) {
      browserType = "Chrome"; // 谷歌
  } else if (ua.match(/safari/) != null) {
      browserType = "Safari"; // Safari
  }
  var arr = new Array(browserType, browserVersion);
  return arr;
}

router.beforeEach((to, from, next) => {
  if (router.app.$options.store.state.piaochuang) {
    clearInterval(router.app.$options.store.state.piaochuang)
    router.app.$options.store.commit("piaochuang", false)
  }

  router.app.$options.store.state.home
  if (to.matched.length === 0) {
    // next('/404')
    return
  }
  let browserArr = checkBrowser();
  if (browserArr[0] == "IE") {
    alert("请在其他非IE浏览器进行访问！推荐使用谷歌或火狐等现代浏览器");
    next('/404')
      }
  // 如果跳转的页面不存在，跳转到404页面
  if (!getToken()) {
    gethomeinfo().then(system => {
      router.app.$options.store.commit("home", system)
      router.app.$options.store.commit("userInfo", false);
    })
  }
   if (getToken()) {
    if (router.app.$options.store.state.userInfo && router.app.$options.store.state.home && router.app.$options.store.state.roles) {
      routerNext(to, from, next, router.app.$options.store.state.home, router.app.$options.store.state.userInfo)
    } else {
      gethomeinfo().then(system => {
        userinfo().then(response => {
          router.app.$options.store.commit("home", system)
          routerNext(to,from,next,system,response)
          createActive().then(() => {})
          router.app.$options.store.commit("home", system)
          routerNext(to,from,next,system,response)
        }).catch(() => {
          router.app.$options.store.commit("tabsIndex", 0);
          // next('/')
      })
      })
        .catch(() => {
          router.app.$options.store.commit("tabsIndex", 0);
          // next('/')
      })
    }
    
  } else if (trueNologin(to.name)) {
    
    if (to.name === 'indexPage') {
      router.app.$options.store.commit("tabsIndex", 0);
    } else if (to.name === 'wdkc') {
      router.app.$options.store.commit("tabsIndex", 1);
    } else if (to.name === 'wdks') {
      router.app.$options.store.commit("tabsIndex", 2);
    } else if (to.name === 'sxpt') {
      router.app.$options.store.commit("tabsIndex", 3);
    } else if (to.name === 'lxwm') {
      router.app.$options.store.commit("tabsIndex", 4);
    } else {
      router.app.$options.store.commit("tabsIndex", -1);
    }
    next()
  } else {
    MessageBox.confirm('尚未登陆，请登录后访问', '提示', {
      confirmButtonText: '登陆',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      next('/login')
    }).catch(() => {
      router.app.$options.store.commit("tabsIndex", 0);
      next('/')
    });
  }
 })

function routerNext(to,from,next,system,response) {
  const data = response
  const roles = roleTrue(data.certificate, data.isEnrolled, data.headquarters)
  router.app.$options.store.commit("roles", roles);
  router.app.$options.store.commit("userInfo", data);
  if ( !data.wxMobile && data.wxCodeState) {
    // next('/')
    if (to.name == 'indexPage' || to.name == 'login') {
      next()
    } else {
      next('/')
    }
    return
  }

  if (roles === 'notEnrolled') {
    if (trueEnrolled(to.name)) {
      Message({
        message: '您的账号没有权限前往此处',
        type: 'error',
        duration: 5 * 1000
      })
      router.app.$options.store.commit("tabsIndex", 0);
      next('/')
    } else {
      if (to.name === 'indexPage') {
        router.app.$options.store.commit("tabsIndex", 0);
      } else if (to.name === 'wdkc') {
        router.app.$options.store.commit("tabsIndex", 1);
      } else if (to.name === 'wdks') {
        router.app.$options.store.commit("tabsIndex", 2);
      } else if (to.name === 'sxpt') {
        router.app.$options.store.commit("tabsIndex", 3);
      } else if (to.name === 'lxwm') {
        router.app.$options.store.commit("tabsIndex", 4);
      } else {
        router.app.$options.store.commit("tabsIndex", -1);
      }
      next()
    }
  }
  else if (roles === 'certificate') {
    
    if (trueCertificate(to.name)) {
      Message({
        message: '您的账号没有权限前往此处',
        type: 'error',
        duration: 5 * 1000
      })
      router.app.$options.store.commit("tabsIndex", 0);
      next('/')
    } else {
      if (to.name === 'indexPage') {
        router.app.$options.store.commit("tabsIndex", 0);
      } else if (to.name === 'wdkc') {
        router.app.$options.store.commit("tabsIndex", 1);
      } else if (to.name === 'wdks') {
        router.app.$options.store.commit("tabsIndex", 2);
      } else if (to.name === 'sxpt') {
        router.app.$options.store.commit("tabsIndex", 3);
      } else if (to.name === 'lxwm') {
        router.app.$options.store.commit("tabsIndex", 4);
      } else {
        router.app.$options.store.commit("tabsIndex", -1);
      }
      next()
    }
  }
  else {
    if (to.name === 'bmdj') {
      if (trueCertificate(to.name)) {
        Message({
          message: '您的账号没有权限前往此处',
          type: 'error',
          duration: 5 * 1000
        })
        router.app.$options.store.commit("tabsIndex", 0);
        next('/')
      } else {
        router.app.$options.store.commit("tabsIndex", 0);
        next('/')
      }
    } else {
      if (to.name === 'indexPage') {
        router.app.$options.store.commit("tabsIndex", 0);
      } else if (to.name === 'wdkc') {
        router.app.$options.store.commit("tabsIndex", 1);
      } else if (to.name === 'wdks') {
        router.app.$options.store.commit("tabsIndex", 2);
      } else if (to.name === 'sxpt') {
        router.app.$options.store.commit("tabsIndex", 3);
      } else if (to.name === 'lxwm') {
        router.app.$options.store.commit("tabsIndex", 4);
      } else {
        router.app.$options.store.commit("tabsIndex", -1);
      }
      next()
    }
  }
 }

export default router



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js